"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClosureInfoForDate = void 0;
const dayjs = require("dayjs");
const getClosureInfoForDate = (date, closures) => {
    let fullday_closure = false;
    let partial_closure = false;
    let start_closure = false;
    let end_closure = false;
    if (closures.length > 0) {
        // if the current closure start and end dates are before and after the current date, then it is a full day closure
        closures.forEach((closure) => {
            if (dayjs(date).isAfter(dayjs(closure.start_date)) &&
                dayjs(date).isBefore(dayjs(closure.end_date))) {
                fullday_closure = true;
            }
            else {
                partial_closure = true;
                //is it the start or end of the closure?
                if (dayjs(date)
                    .startOf("day")
                    .isSame(dayjs(closure.start_date).startOf("day"))) {
                    start_closure = true;
                }
                if (dayjs(date)
                    .startOf("day")
                    .isSame(dayjs(closure.end_date).startOf("day"))) {
                    end_closure = true;
                }
            }
        });
    }
    return {
        fullday_closure,
        partial_closure,
        start_closure,
        end_closure,
    };
};
exports.getClosureInfoForDate = getClosureInfoForDate;
